<template>
    <CreateModelLayout
        :indexRoute="$route('admin::time-entries.index')"
        :storeRoute="$route('admin::time-entries.store')"
        :modelNameSingular="__('admin::time_entries.time_entry')"
        :modelNamePlural="__('admin::time_entries.time-entries')"
        :form="form"
    >

        <FormGroup :label="__('admin::labels.user')" :error="errors.user_id">
            <Select name="user_id" :options="userOptions" :has-error="exists(errors.user_id)" v-model="form.user_id" allow-empty :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.date')" :error="errors.date">
            <Datepicker name="date" :has-error="exists(errors.date)" v-model="form.date" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.checked_in_at')" :error="errors.checked_in_at">
            <Datepicker mode="time" name="checked_in_at" :has-error="exists(errors.checked_in_at)" v-model="form.checked_in_at" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.checked_out_at')" :error="errors.checked_out_at">
            <Datepicker mode="time" name="checked_out_at" :has-error="exists(errors.checked_out_at)" v-model="form.checked_out_at" :required="false" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.notes')" :error="errors.notes">
            <Textarea name="notes" :has-error="exists(errors.notes)" v-model="form.notes" :required="false" />
        </FormGroup>

    </CreateModelLayout>
</template>

<script>
export default {
    props: {
        errors: Object,
        userOptions: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                user_id: '',
                date: this.$date(new Date(), 'YYYY-MM-DD'),
                checked_in_at: '08:00:00',
                checked_out_at: null,
                notes: null,
            })
        }
    },
}
</script>
